module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row scale positive"
  }, [_c('div', {
    staticClass: "col-md-2 scale-title"
  }, [_vm._v("Positive")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 scale-choices",
    class: {
      editable: _vm.isEditable
    }
  }, [_c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "ghost-class": "choice-ghost",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.positiveChoices),
      callback: function($$v) {
        _vm.positiveChoices = $$v
      },
      expression: "positiveChoices"
    }
  }, [_vm._l((_vm.positiveChoices), function(choice) {
    return _c('scale-choice-item', {
      key: choice.id,
      class: {
        draggable: _vm.isEditable
      },
      attrs: {
        "choice": choice,
        "question": _vm.question,
        "isEditable": _vm.isEditable
      },
      on: {
        "onUpdateChoice": _vm.handleUpdateChoice,
        "onEmpty": function($event) {
          return _vm.handleRemove(choice.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemove(choice.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n            Drag choice or\n            "), _c('a', {
    on: {
      "click": _vm.handleCreatePositiveChoice
    }
  }, [_vm._v("Create a new choice")])])]) : _vm._e()], 2)], 1)]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "row scale neutral m-sm"
  }, [_c('div', {
    staticClass: "col-md-2 scale-title"
  }, [_vm._v("Neutral")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 scale-choices",
    class: {
      editable: _vm.isEditable
    }
  }, [_c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "ghost-class": "choice-ghost",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.neutralChoices),
      callback: function($$v) {
        _vm.neutralChoices = $$v
      },
      expression: "neutralChoices"
    }
  }, [_vm._l((_vm.neutralChoices), function(choice) {
    return _c('scale-choice-item', {
      key: choice.id,
      class: {
        draggable: _vm.isEditable
      },
      attrs: {
        "choice": choice,
        "question": _vm.question,
        "isEditable": _vm.isEditable
      },
      on: {
        "onUpdateChoice": _vm.handleUpdateChoice,
        "onEmpty": function($event) {
          return _vm.handleRemove(choice.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemove(choice.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n            Drag choice or\n            "), _c('a', {
    on: {
      "click": _vm.handleCreateNeutralChoice
    }
  }, [_vm._v("Create a new choice")])])]) : _vm._e()], 2)], 1)]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "row scale negative m-sm"
  }, [_c('div', {
    staticClass: "col-md-2 scale-title"
  }, [_vm._v("Negative")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 scale-choices",
    class: {
      editable: _vm.isEditable
    }
  }, [_c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "ghost-class": "choice-ghost",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.negativeChoices),
      callback: function($$v) {
        _vm.negativeChoices = $$v
      },
      expression: "negativeChoices"
    }
  }, [_vm._l((_vm.negativeChoices), function(choice) {
    return _c('scale-choice-item', {
      key: choice.id,
      class: {
        draggable: _vm.isEditable
      },
      attrs: {
        "choice": choice,
        "question": _vm.question,
        "isEditable": _vm.isEditable
      },
      on: {
        "onUpdateChoice": _vm.handleUpdateChoice,
        "onEmpty": function($event) {
          return _vm.handleRemove(choice.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemove(choice.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n            Drag choice or\n            "), _c('a', {
    on: {
      "click": _vm.handleCreateNegativeChoice
    }
  }, [_vm._v("Create a new choice")])])]) : _vm._e()], 2)], 1)]), _vm._v(" "), (_vm.isEditable) ? _c('div', [_c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "row scale m-sm"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Present in reverse order"
    },
    model: {
      value: (_vm.reverseOrder),
      callback: function($$v) {
        _vm.reverseOrder = $$v
      },
      expression: "reverseOrder"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [(_vm.isEditable) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("   Clear all choices\n    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSaveTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("   Save as new Choice Template\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-023354e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/scale/ScaleEditorExpanded.vue
// module id = 3114
// module chunks = 3